import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initUpdateChecker } from './store/updateStore';
import { markBootStart, watchForHealthyBoot } from './utils/bootGuard';
import './index.css';

// FIRST, before anything that could kill the tab (BUG-120): count this launch,
// and decide whether the last two died. A crash cannot write its own epitaph,
// so the attempt is recorded up front and erased once the launch survives.
markBootStart();
watchForHealthyBoot();

// Initialize update checking system
initUpdateChecker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
